import eventTrack from '@/api/eventTrack'

export default {
  //数据埋点
  eventTrack: (data = {}) => {
    data.actId = 'festivalActivity'

    return eventTrack['621000'](data)
  }
}



// WEBPACK FOOTER //
// ./src/projects/festivalActivity/epidemic/service/index.js